import { StatusFeedback, Text } from '../../../components/core';
import { IconAlertCircle } from '../../../components/icons/IconAlertCircle';
import { IconAlertTriangle } from '../../../components/icons/IconAlertTriangle';
import { Portals } from '../../../content/portal/portals';
import { usePortalNavigate } from '../../../content/portal/usePortalNavigate';
import { useBreakpointSwitch } from '../../../contexts/breakpointContext';
import { usePortalContext } from '../../../contexts/portalContext';
import { getRoute, useExternalNavigate } from '../../../routes';

export const CareRecommendationCrisisFeedback = (): JSX.Element => {
  const portalNavigate = usePortalNavigate();
  const { onlyIfPortalIsActive } = usePortalContext();
  const [verticalFeedback] = useBreakpointSwitch({
    mobile: [true],
    desktop: [false],
  });

  const connectNowEnabled = onlyIfPortalIsActive(Portals.ConnectNow, true, false);

  const buttonText = connectNowEnabled ? 'Visit ConnectNow' : 'View Crisis Resources';

  const warningText = connectNowEnabled
    ? 'Answers to this form are not monitored in real time. If you need immediate support, use ConnectNow or a provided crisis resource.'
    : 'Answers to this form are not monitored in real time. If you need immediate support, please see available crisis resources.';

  return (
    <StatusFeedback.warning
      Icon={IconAlertTriangle}
      isLink
      buttonText={buttonText}
      testID="care-recommendation-crisis-status-feedback"
      onPress={() =>
        portalNavigate(
          Portals.ConnectNow,
          getRoute('connectNowHome', {}),
          getRoute('crisisResources', {}),
        )
      }
      vertical={verticalFeedback}
    >
      <Text.paraSmall bold>Reminder:</Text.paraSmall> {warningText}
    </StatusFeedback.warning>
  );
};

export const CoachingSelfCareFeedback = (): JSX.Element => {
  const externalNavigate = useExternalNavigate();
  const [verticalFeedback] = useBreakpointSwitch({
    mobile: [true],
    desktop: [false],
  });
  return (
    <StatusFeedback.info
      Icon={IconAlertCircle}
      isLink
      testID="coaching-self-care-status-feedback"
      buttonText="Get in Touch"
      onPress={() => externalNavigate('mailto:hi@mantrahealth.com')}
      vertical={verticalFeedback}
    >
      <Text.para bold>Looking for therapy?</Text.para> Contact our team to get connected with a
      Mantra therapist.
    </StatusFeedback.info>
  );
};
